class ProductUnitDataModalController extends AbstractController
	@register()
	@inject '$uibModalInstance',
		'service'
		'setFormsDirty'

	initialize: ->
		@service.initializeUnitData()
		@service.handleDataChanges()

	closeModal: (persistData) ->
		if !persistData
			@$uibModalInstance.close persistData

			return

		@service.persistData()
		@setFormsDirty()
		@$uibModalInstance.close persistData
